var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag is-primary"},[_vm._v(" "+_vm._s(_vm.filter.label)+": "+_vm._s(_vm.value)+"  "),_c('button',{staticClass:"delete is-small",on:{"click":_vm.dropFilter}})])}
var staticRenderFns = []

export { render, staticRenderFns }